import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

interface UseConfirmFiscalDocument {
  id: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

const useBillingEventConfirmFiscalDocument = ({ id, onSuccess, onError }: UseConfirmFiscalDocument) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['confirmFiscalDocument', id],
    mutationFn: async () => {
      return await privateAxios.post(`/billing/events/${id}/confirm_fiscal_document`);
    },
    onSuccess,
    onError,
  });
};

export default useBillingEventConfirmFiscalDocument;
